export default {
  title: {
    id: 'profile_page_title',
    defaultMessage: 'Your business account',
  },
  navigation: {
    id: 'profile_page_navigation_title',
    defaultMessage: 'Profile navigation',
  },
  homeTab: {
    id: 'profile_page_home_tab',
    defaultMessage: 'Home',
  },
  legalDetailsTab: {
    id: 'profile_page_legal_details_tab',
    defaultMessage: 'Legal details',
  },
  contactDetailsTab: {
    id: 'profile_page_contact_details_tab',
    defaultMessage: 'Contact details',
  },
  companyInfoTab: {
    id: 'profile_page_company_info_tab',
    defaultMessage: 'Company info',
  },
  userPermissionsTab: {
    id: 'profile_page_company_user_permissions_tab',
    defaultMessage: 'User permissions',
  },
}
